import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  CreateUserBankAccountRequestDto,
  CreateUserBankAccountResponseDto,
  ReadUserBankAccountsRequestDto,
  ReadUserBankAccountsResponseDto,
  UpdateUserBankAccountResponseDto,
  DeleteUserBankAccountRequestDto,
  DeleteUserBankAccountResponseDto,
  CreateUserWalletRequestDto,
  CreateUserWalletResponseDto,
  ReadUserWalletsRequestDto,
  ReadUserWalletsResponseDto,
  UpdateUserWalletRequestDto,
  UpdateUserWalletResponseDto,
  DeleteUserWalletRequestDto,
  DeleteUserWalletResponseDto,
  ReadUserSfBankAccountRequestDto,
  ReadUserSfBankAccountResponseDto,
  ReadUserSfWalletsRequestDto,
  ReadUserSfWalletsResponseDto,
  WebAccessTokenPayloadDto,
  UpdateBankAccountRequestDto,
  IUserWallet,
  ReadClientTypesForAssignToUserRequestDto,
  ReadClientTypesForAssignToUserResponseDto,
  UserClientTypeRequestDto,
  UserClientTypeResponseDto,
  IUserBankAccount,
} from '@sparling/financial-common'

export const {
  request: getUserRequest,
  success: getUserSuccess,
  failure: getUserFailure,
} = createAsyncAction('GET_USER_REQUEST', 'GET_USER_SUCCESS', 'GET_USER_FAILURE')<
  { accessToken: string; after2fa?: boolean } | null,
  WebAccessTokenPayloadDto | null,
  Error | null
>()

export const {
  request: createUserBankAccountRequest,
  success: createUserBankAccountSuccess,
  failure: createUserBankAccountFailure,
} = createAsyncAction(
  'CREATE_USER_BANK_ACCOUNT_REQUEST',
  'CREATE_USER_BANK_ACCOUNT_SUCCESS',
  'CREATE_USER_BANK_ACCOUNT_FAILURE',
)<CreateUserBankAccountRequestDto, CreateUserBankAccountResponseDto, Error>()

export const {
  request: readUserBankAccountsRequest,
  success: readUserBankAccountsSuccess,
  failure: readUserBankAccountsFailure,
} = createAsyncAction(
  'READ_USER_BANK_ACCOUNTS_REQUEST',
  'READ_USER_BANK_ACCOUNTS_SUCCESS',
  'READ_USER_BANK_ACCOUNTS_FAILURE',
)<ReadUserBankAccountsRequestDto, ReadUserBankAccountsResponseDto, Error>()

export const {
  request: updateUserBankAccountRequest,
  success: updateUserBankAccountSuccess,
  failure: updateUserBankAccountFailure,
} = createAsyncAction(
  'UPDATE_USER_BANK_ACCOUNT_REQUEST',
  'UPDATE_USER_BANK_ACCOUNT_SUCCESS',
  'UPDATE_USER_BANK_ACCOUNT_FAILURE',
)<
  UpdateBankAccountRequestDto & {
    id: number
  },
  UpdateUserBankAccountResponseDto,
  Error
>()

export const {
  request: getUserBankAccountListRequest,
  success: getUserBankAccountListSuccess,
  failure: getUserBankAccountListFailure,
} = createAsyncAction(
  'GET_USER_BANK_ACCOUNT_LIST_REQUEST',
  'GET_USER_BANK_ACCOUNT_LIST_SUCCESS',
  'GET_USER_BANK_ACCOUNT_LIST_FAILURE',
)<void, IUserBankAccount[], Error>()

export const {
  request: deleteUserBankAccountRequest,
  success: deleteUserBankAccountSuccess,
  failure: deleteUserBankAccountFailure,
} = createAsyncAction(
  'DELETE_USER_BANK_ACCOUNT_REQUEST',
  'DELETE_USER_BANK_ACCOUNT_SUCCESS',
  'DELETE_USER_BANK_ACCOUNT_FAILURE',
)<
  DeleteUserBankAccountRequestDto & {
    id: number
  },
  DeleteUserBankAccountResponseDto,
  Error
>()

export const {
  request: createUserWalletRequest,
  success: createUserWalletSuccess,
  failure: createUserWalletFailure,
} = createAsyncAction('CREATE_USER_WALLET_REQUEST', 'CREATE_USER_WALLET_SUCCESS', 'CREATE_USER_WALLET_FAILURE')<
  CreateUserWalletRequestDto,
  CreateUserWalletResponseDto,
  string
>()

export const {
  request: readUserWalletsRequest,
  success: readUserWalletsSuccess,
  failure: readUserWalletsFailure,
} = createAsyncAction('READ_USER_WALLETS_REQUEST', 'READ_USER_WALLETS_SUCCESS', 'READ_USER_WALLETS_FAILURE')<
  ReadUserWalletsRequestDto,
  ReadUserWalletsResponseDto,
  Error
>()

export const {
  request: updateUserWalletRequest,
  success: updateUserWalletSuccess,
  failure: updateUserWalletFailure,
} = createAsyncAction('UPDATE_USER_WALLET_REQUEST', 'UPDATE_USER_WALLET_SUCCESS', 'UPDATE_USER_WALLET_FAILURE')<
  UpdateUserWalletRequestDto & {
    id: number
  },
  UpdateUserWalletResponseDto,
  Error
>()

export const {
  request: deleteUserWalletRequest,
  success: deleteUserWalletSuccess,
  failure: deleteUserWalletFailure,
} = createAsyncAction('DELETE_USER_WALLET_REQUEST', 'DELETE_USER_WALLET_SUCCESS', 'DELETE_USER_WALLET_FAILURE')<
  DeleteUserWalletRequestDto & {
    id: number
  },
  DeleteUserWalletResponseDto,
  Error
>()

export const {
  request: readUserSfBankAccountsRequest,
  success: readUserSfBankAccountsSuccess,
  failure: readUserSfBankAccountsFailure,
} = createAsyncAction(
  'READ_USER_SF_BANK_ACCOUNTS_REQUEST',
  'READ_USER_SF_BANK_ACCOUNTS_SUCCESS',
  'READ_USER_SF_BANK_ACCOUNTS_FAILURE',
)<Omit<ReadUserSfBankAccountRequestDto, 'idSf'>, ReadUserSfBankAccountResponseDto, Error>()

export const {
  request: readUserSfWalletsRequest,
  success: readUserSfWalletsSuccess,
  failure: readUserSfWalletsFailure,
} = createAsyncAction('READ_USER_SF_WALLETS_REQUEST', 'READ_USER_SF_WALLETS_SUCCESS', 'READ_USER_SF_WALLETS_FAILURE')<
  Omit<ReadUserSfWalletsRequestDto, 'idSf'>,
  ReadUserSfWalletsResponseDto,
  Error
>()

export const userBaseCurrencyUpdated = createAction('USER_BASE_CURRENCY_UPDATED')<string>()

export const {
  request: getUserWalletListRequest,
  success: getUserWalletListSuccess,
  failure: getUserWalletListFailure,
} = createAsyncAction('GET_USER_WALLET_LIST_REQUEST', 'GET_USER_WALLET_LIST_SUCCESS', 'GET_USER_WALLET_LIST_FAILURE')<
  void,
  IUserWallet[],
  Error
>()

export const {
  request: getClientTypesForAssignToUserRequest,
  success: getClientTypesForAssignToUserSuccess,
  failure: getClientTypesForAssignToUserFailure,
} = createAsyncAction(
  'GET_CLIENT_TYPES_FOR_ASSIGN_TO_USER_REQUEST',
  'GET_CLIENT_TYPES_FOR_ASSIGN_TO_USER_SUCCESS',
  'GET_CLIENT_TYPES_FOR_ASSIGN_TO_USER_FAILURE',
)<ReadClientTypesForAssignToUserRequestDto, ReadClientTypesForAssignToUserResponseDto, Error>()

export const {
  request: userClientTypeRequest,
  success: userClientTypeSuccess,
  failure: userClientTypeFailure,
} = createAsyncAction('USER_CLIENT_TYPE_REQUEST', 'USER_CLIENT_TYPE_SUCCESS', 'USER_CLIENT_TYPE_FAILURE')<
  UserClientTypeRequestDto,
  UserClientTypeResponseDto,
  Error
>()
